module.exports = __webpack_public_path__ + "img/add.4ab53a12.svg";